import { Box, BoxProps } from "@mui/material";

interface CustomSvgIconProps {
  src?: string;
  sx?: BoxProps["sx"];
}

const CustomSvgIcon: React.FC<CustomSvgIconProps> = ({ src, sx }) => {
  return (
    <Box
      component="span"
      sx={{
        width: 24,
        height: 24,
        display: "inline-block",
        bgcolor: "currentColor",
        mask: `url(${src}) no-repeat center / contain`,
        WebkitMask: `url(${src}) no-repeat center / contain`,
        ...sx,
      }}
    />
  );
};

export default CustomSvgIcon;
